export const translate = (language, german, english, simpleGerman) => {
    if(language === "german") {
        return german;
}
if(language === "english") {
        return english;
}
if(language === "simpleGerman") {
        return simpleGerman;
}
    
} 